/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindingsSummaryResponse
 */
export interface FindingsSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof FindingsSummaryResponse
     */
    findingsSatisfied?: number;
    /**
     * 
     * @type {number}
     * @memberof FindingsSummaryResponse
     */
    findingsNotSatisfied?: number;
}

/**
 * Check if a given object implements the FindingsSummaryResponse interface.
 */
export function instanceOfFindingsSummaryResponse(value: object): value is FindingsSummaryResponse {
    return true;
}

export function FindingsSummaryResponseFromJSON(json: any): FindingsSummaryResponse {
    return FindingsSummaryResponseFromJSONTyped(json, false);
}

export function FindingsSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingsSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'findingsSatisfied': json['findingsSatisfied'] == null ? undefined : json['findingsSatisfied'],
        'findingsNotSatisfied': json['findingsNotSatisfied'] == null ? undefined : json['findingsNotSatisfied'],
    };
}

export function FindingsSummaryResponseToJSON(json: any): FindingsSummaryResponse {
    return FindingsSummaryResponseToJSONTyped(json, false);
}

export function FindingsSummaryResponseToJSONTyped(value?: FindingsSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'findingsSatisfied': value['findingsSatisfied'],
        'findingsNotSatisfied': value['findingsNotSatisfied'],
    };
}

